import React, { useMemo } from "react";
import { useModelFilterSelector } from "../../../../redux/store";
import ActiveFilterSlider from "./ActiveFilterSlider";
import { ModelFilterId } from "../../../../utils/constants/filterConstants";

/**
 * Container for the ActiveFilterSlider.
 * This container is required because the ActiveFilterSlider works with a two pass rendering system so it cannot hide itself.
 */
const ActiveFilterSliderContainer = (): JSX.Element | null => {
    const modelFilters = useModelFilterSelector((state) => state.modelFilters);

    const sliderComponents = Object.values(ModelFilterId)
        .filter((filterId) => modelFilters[filterId].active)
        .sort((a, b) => modelFilters[a].index - modelFilters[b].index);

    const filtersKey = [...sliderComponents].sort().join();

    // Prevent unnecessary rerenders by using filtersKey, which is also used in ActiveFilterSlider to prevent rerenders.
    return useMemo(
        () =>
            sliderComponents.length === 0 ? null : (
                <ActiveFilterSlider activeFilters={sliderComponents} activeFiltersKey={filtersKey} />
            ),
        [filtersKey],
    );
};

export default ActiveFilterSliderContainer;
